<script setup lang="ts">
import SearchTypeToggle from '@/components/AgencySearchBar/SearchTypeToggle.vue';

defineProps<{
  activeType: 'agency' | 'agent';
}>();
</script>

<template>
  <div :class="$style.searchBarWrapper">
    <div :class="$style.searchTypeWrapper">
      <SearchTypeToggle :activeType="activeType" />
    </div>
    <div :class="$style.locationsWrapper">
      <slot name="locations" />
    </div>
    <div v-if="$slots.filters" :class="$style.filtersWrapper">
      <slot name="filters" />
    </div>
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.searchBarWrapper {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: $space-100;
  padding-block: $space-100;
  margin-top: $space-150;
  background-color: $color-white;
  border-radius: $border-radius-l;

  @media (min-width: $viewport-sm-min) {
    grid-template-columns: auto 1fr;
    column-gap: $space-150;
    align-items: end;
  }
}

.searchTypeWrapper {
  grid-row-start: 1;
}

.locationsWrapper {
  grid-row-start: 2;

  @media (min-width: $viewport-sm-min) {
    grid-row-start: 1;
    grid-column-start: 2;
  }
}

.filtersWrapper {
  grid-row-start: 3;
  padding-top: $space-50;

  @media (min-width: $viewport-sm-min) {
    grid-row-start: 2;
    grid-column: 1 / -1;
  }
}
</style>
